import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LangState {
    lang: "ar" | "en" | null;
    setLang: (lang: "ar" | "en") => void;
}

const useLangStore = create<LangState>()(
    persist(
        (set) => ({
            lang: null,
            setLang: (lang) => set({ lang }),
        }),
        { name: "lang" }
    )
);

export default useLangStore;
